export const manifest = {
  screens: {
    scr_w9qqbm: { name: "Home", route: "/" },
  },
}
